import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AuthService } from '@features/auth';

export type ConsentStatus = 'accepted' | 'declined' | 'pending';

@Component({
  selector: 'app-consent-banner',
  templateUrl: './consent-banner.component.html',
  styleUrls: ['./consent-banner.component.scss'],
  imports: [RouterLink],
})
export class ConsentBannerComponent {
  protected auth = inject(AuthService);

  protected status = signal<ConsentStatus>('pending');

  protected accept(guest: boolean) {
    this.respond(true, guest);
  }

  protected decline(guest: boolean) {
    this.respond(false, guest);
  }

  private respond(accepted: boolean, _guest: boolean) {
    this.status.set(accepted ? 'accepted' : 'declined');
  }
}
